import { render } from "./TextButton.vue?vue&type=template&id=6d01fe98&ts=true"
import script from "./TextButton.vue?vue&type=script&lang=ts"
export * from "./TextButton.vue?vue&type=script&lang=ts"

import "./TextButton.vue?vue&type=style&index=0&id=6d01fe98&lang=scss"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__